module.exports = __webpack_public_path__ + "img/new_price_sp.0245093d.png";